import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgInactiveEnvelope = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="64"
        width="65"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 65 64"
    >
        <rect
            fill="#EDEBEB"
            height="64.0001"
            rx="32"
            width="64.0001"
            x="0.391113"
        />
        <path
            d="M12.3916 25.889L29.5841 12.7386C30.7562 11.843 32.3699 11.7997 33.5875 12.6339L52.1606 25L52.1606 49L12.8787 49.8103L12.3916 25.889Z"
            fill="white"
        />
        <path
            d="M47.5513 36.5644L18.2609 38.3559L17.0091 17.8898C16.9372 16.7138 17.8322 15.7022 19.0082 15.6302L44.0399 14.0992C45.2159 14.0273 46.2276 14.9223 46.2995 16.0983L47.5513 36.5644Z"
            fill="#B5ADAD"
        />
        <path
            d="M32.4667 34.2977L33.6656 34.2453L33.6033 32.8181C36.3749 32.5446 37.8614 30.7828 37.7684 28.6515C37.6645 26.2728 35.5587 25.6403 34.3242 25.3129L33.261 24.978L33.1363 22.1235C33.8885 22.3195 34.5232 22.8828 34.8211 23.5943L37.0582 22.429C36.6566 21.0928 35.1696 19.785 33.0275 19.6307L32.9677 18.2606L31.7688 18.3129L31.8278 19.664C29.5716 19.9532 27.8278 21.4974 27.9258 23.7428C28.0297 26.1215 30.3514 26.8972 31.6041 27.2047L32.1635 27.3519L32.2939 30.3395C31.4483 30.1858 30.6804 29.6283 30.25 28.5031L27.7903 29.3732C28.4344 31.4613 30.1101 32.7228 32.4036 32.8514L32.4667 34.2977ZM30.7107 23.3353C30.6833 22.7073 31.0828 22.2513 31.9342 22.0998L32.0438 24.6117C31.2694 24.3404 30.7406 24.0203 30.7107 23.3353ZM33.4953 30.3443L33.3781 27.6611C34.2279 27.91 34.8137 28.2276 34.8469 28.9888C34.8769 29.6739 34.3077 30.1754 33.4953 30.3443Z"
            fill="white"
        />
        <path
            d="M12.3911 25.8895L32.6141 39.6874L12.6606 51.0001L12.3911 25.8895Z"
            fill="#F8F8F8"
        />
        <path
            d="M52.1606 25L31.8379 40.0108L52.1606 50.5L52.1606 25Z"
            fill="#F8F8F8"
        />
        <path
            d="M52.1606 50.5L34.4818 37.7306C33.2754 36.8833 31.6613 36.9064 30.4802 37.7878L12.6606 51L52.1606 50.5Z"
            fill="#DAD7D7"
        />
    </svg>
);

export const InactiveEnvelopeIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgInactiveEnvelope}
        fontSize={fontSize}
    />
);
